module.exports = __webpack_public_path__ + "images/139_1024.jpg";